require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-exercise-self-care.json") })
        }
      }, "path---blog-exercise-self-care");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-exercise-self-care!./.cache/json/blog-exercise-self-care.json
// module id = 286
// module chunks = 231608221292675